var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '마이페이지'
    }
  }), _c('mypage-navigation'), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "Application status",
      "tit": "신청 현황"
    }
  }), _c('v-data-table', _vm._b({
    staticClass: "v-data-table--default",
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: "item.state",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-chip', {
          attrs: {
            "color": _vm.stateColor(item),
            "label": ""
          }
        }, [_c('span', {
          staticClass: "white--text"
        }, [_vm._v(_vm._s(_vm.stateText(item)))])])];
      }
    }, {
      key: "item.cancel",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-btn', {
          staticClass: "v-btn--table",
          attrs: {
            "disabled": !_vm.isCancelable(item),
            "outlined": "",
            "small": "",
            "rounded": "",
            "elevation": "0",
            "color": "grey"
          },
          on: {
            "click": function click($event) {
              return _vm.cancel(item);
            }
          }
        }, [_c('span', {
          staticClass: "grey-dark--text"
        }, [_vm._v("신청취소")])])];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('pagination-component', {
          attrs: {
            "value": _vm.page,
            "count": _vm.pageCount
          },
          on: {
            "input": function input(page) {
              return _vm.$router.push({
                query: {
                  page: page
                }
              });
            }
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }